import { render, staticRenderFns } from "./AssemblySelector.vue?vue&type=template&id=5a01e1ca&scoped=true&"
import script from "./AssemblySelector.vue?vue&type=script&lang=js&"
export * from "./AssemblySelector.vue?vue&type=script&lang=js&"
import style0 from "./AssemblySelector.vue?vue&type=style&index=0&id=5a01e1ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a01e1ca",
  null
  
)

export default component.exports